// extracted by mini-css-extract-plugin
export default {"bgWhite":"Privacy_bgWhite__a-fu2","height":"Privacy_height__VuVwq","sucesss":"Privacy_sucesss__IJ-aK","sucessFailed":"Privacy_sucessFailed__XRf6V"};